"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconStorageRoomFilled = function IconStorageRoomFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.07 33H18V6.49001C18 6.09218 17.842 5.71065 17.5607 5.42935C17.2794 5.14804 16.8978 4.99001 16.5 4.99001C16.1022 4.99001 15.7206 5.14804 15.4393 5.42935C15.158 5.71065 15 6.09218 15 6.49001V33H11.93C11.6851 33 11.45 33.0966 11.2759 33.2689C11.1018 33.4411 11.0026 33.6751 11 33.92V35.08C11.0026 35.3249 11.1018 35.5589 11.2759 35.7312C11.45 35.9034 11.6851 36 11.93 36H21.07C21.3149 36 21.55 35.9034 21.7241 35.7312C21.8982 35.5589 21.9974 35.3249 22 35.08V33.92C21.9974 33.6751 21.8982 33.4411 21.7241 33.2689C21.55 33.0966 21.3149 33 21.07 33Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.44 45H11.56C11.18 45 11.03 44.54 11 44.22C10.9951 44.1969 10.9951 44.1731 11 44.15C11 44.08 11.11 44.01 11.16 43.96C11.21 43.91 11.29 43.8 11.35 43.71C11.4715 43.5477 11.5817 43.3773 11.68 43.2C11.8832 42.8454 12.0284 42.4605 12.11 42.06C12.2628 41.3032 12.1934 40.5182 11.91 39.8C11.8167 39.5702 11.7029 39.3493 11.57 39.14C11.3721 38.8686 11.217 38.5684 11.11 38.25L11 37.86C11 37.39 11.25 37 11.56 37H21.44C21.75 37 22 37.39 22 37.86L21.91 38.17C21.7685 38.5963 21.6015 39.0137 21.41 39.42C21.1352 40.0576 21.0104 40.7498 21.0451 41.4432C21.0797 42.1367 21.273 42.8129 21.61 43.42L21.76 43.69L21.88 43.91C21.9355 43.9775 21.9764 44.0558 22 44.14V44.21C22 44.54 21.81 45 21.44 45Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39 33.35L36.37 44C36.2608 44.3058 36.0558 44.5683 35.7856 44.7484C35.5154 44.9286 35.1943 45.0168 34.87 45H28.13C27.8051 45.0201 27.4825 44.9332 27.2116 44.7526C26.9407 44.572 26.7365 44.3077 26.63 44L24 33.36C23.9851 33.2572 23.9851 33.1528 24 33.05C26.0777 33.9873 28.3417 34.4387 30.62 34.37C33.467 34.3447 36.2932 33.8826 39 33C39.024 33.1154 39.024 33.2346 39 33.35Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31 26C30.1588 25.9487 29.316 26.0672 28.5216 26.3485C27.7272 26.6298 26.9975 27.0681 26.3761 27.6373C25.7546 28.2065 25.2541 28.8949 24.9043 29.6616C24.5545 30.4283 24.3626 31.2576 24.34 32.1C25.34 32.65 30.16 34.69 38.58 32.1C38.19 30 36.72 26 31 26ZM25.39 31.81C25.4418 31.1255 25.6282 30.4581 25.9383 29.8457C26.2484 29.2334 26.6763 28.6882 27.1974 28.2414C27.7185 27.7947 28.3225 27.455 28.975 27.242C29.6276 27.029 30.3157 26.9467 31 27C35.6 27 37 29.92 37.48 31.77C33.5285 30.5831 29.3135 30.597 25.37 31.81H25.39Z",
    fill: color
  }));
};

IconStorageRoomFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconStorageRoomFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconStorageRoomFilled;
exports.default = _default;